import { format } from 'date-fns';

export const formatDateToLocalInput = (date: Date): string =>
  format(date, "yyyy-MM-dd'T'HH:mm");
